export const indexdDbWrapper = {
	db: null,
	isAvailable() {
		// In the following line, you should include the prefixes of implementations you want to test.
		const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
		if (!indexedDB) return false;
		return true;
	},
	init() {
		if (this.db !== null) return Promise.resolve();
		return new Promise((resolve, reject) => {
			const indexedDB =
				window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
			const openRequest = indexedDB.open('audioSyncCache', 1);
			openRequest.onupgradeneeded = event => {
				const thisDB = event.target.result;
				if (!thisDB.objectStoreNames.contains('cache')) {
					thisDB.createObjectStore('cache');
				}
			};
			openRequest.onsuccess = event => {
				this.db = event.target.result;
				resolve();
			};
			openRequest.onerror = event => reject(`Could not connect to indexdDB. ${event.target.error}`);
		});
	},
	write(path, data, options = {}) {
		return new Promise((resolve, reject) => {
			const transaction = this.db.transaction(['cache'], 'readwrite');
			transaction.onerror = error => {
				reject(error);
			};
			const objectStore = transaction.objectStore('cache');
			transaction.onerror = error => {
				reject(error);
			};
			const putRequest = options.delete ? objectStore.delete(path) : objectStore.put(data, path);
			putRequest.onerror = event => {
				reject(event.target.error.name);
			};
			putRequest.onsuccess = () => {
				resolve();
			};
			// FIXME add a get here to to check if the value changed, if not raise "disk full" exception
		});
	},
	read(path) {
		return new Promise((resolve, reject) => {
			const request = this.db
				.transaction(['cache'], 'readonly')
				.objectStore('cache')
				.get(path);
			request.onerror = event => reject(`DB Error ${event.target.error.name}`);
			request.onsuccess = () => {
				resolve(request.result);
			};
		});
	},
};
